import {buriedPointFunc} from "./buriedPoint";

// 防抖
export function debounce(func, wait, immediate) {
    let timeout = null
    return function () {
        let context = this
        let args = arguments
        // 一开始是否需要执行
        if (immediate && !timeout) {
            func.apply(context, args)
        }
        if (timeout) clearTimeout(timeout) // 之前的不要了，重新设置一个
        timeout = setTimeout(() => {
            // this指向和arguments处理
            func.apply(context, args)
        }, wait)
    }
}

// 针对点击事件的埋点方法
export function methodsBuriedPoint(action_id, action, params) {
    let obj = {
        title: document.title || "", //页面标题
        actionId: action_id, //事件id
        action: action, //事件名称
        account: "ThemeItem", //系统标识
    }
    // 添加额外的参数
    if (Object.keys(params).length > 0) {
        obj = {...obj, ...params};
    }
    buriedPointFunc(obj)
}
